<template>
  <div>
    <MonthlyWL v-if="isWhitelabel() || isMetrack()" />
    <MonthlyNonWL v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MonthlyNonWL from './NonWhiteLabel.vue'
import MonthlyWL from './WhiteLabel.vue'

export default {
  components: {
    MonthlyNonWL,
    MonthlyWL,
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getAsset: 'asset/getAsset',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import './MonthlyStyle.scss';
</style>
